import { useMemo } from "react";
import { usePricing } from "@/api/hooks/use-pricing";
import { PricingPlan } from "@/api/models/api-types";

export const usePricingData = (queryOptions = {}) => {
  const { data, isLoading, error } = usePricing(queryOptions);

  const plans = useMemo(() => {
    if (!data?.data?.result) return [];
    // sortOrder'a göre sırala (küçükten büyüğe)
    return data.data.result.sort((a, b) => a.sortOrder - b.sortOrder);
  }, [data]);

  const recurringPlans = useMemo(() => {
    return plans.filter((plan: PricingPlan) => plan.planType === "recurring");
  }, [plans]);

  const topupPlans = useMemo(() => {
    return plans.filter((plan: PricingPlan) => plan.planType === "topup");
  }, [plans]);

  const monthlyPlans = useMemo(() => {
    return recurringPlans.filter(
      (plan: PricingPlan) => plan.billingCycle === "monthly"
    );
  }, [recurringPlans]);

  const yearlyPlans = useMemo(() => {
    return recurringPlans.filter(
      (plan: PricingPlan) => plan.billingCycle === "yearly"
    );
  }, [recurringPlans]);

  const featuredPlans = useMemo(() => {
    return plans.filter((plan: PricingPlan) => plan.isFeatured);
  }, [plans]);

  const popularPlans = useMemo(() => {
    return plans.filter((plan: PricingPlan) => plan.isPopular);
  }, [plans]);

  return {
    plans,
    recurringPlans,
    topupPlans,
    monthlyPlans,
    yearlyPlans,
    featuredPlans,
    popularPlans,
    isLoading,
    error,
  };
};
